import React from 'react';
import './Imagine.scss';
import CustomBtn from '../../../../components/CustomBtn/CustomBtn';
import { safeHtml } from '../../../../services/helpers';

export default function Imagine({content, btn_action, isRegistered, slug, systemIoLink}) {
    return (
        <div className='workshop-imagine'>
            {
                content.Texte &&
                    <div className="" dangerouslySetInnerHTML={safeHtml(content.Texte)} />
            }
            {
                content.Bouton &&
                    <CustomBtn
                        type={'external'}
                        title={content.Bouton.TexteBouton}
                        link={content.Bouton.LienBouton}
                        bkg_color={'#7D605C'}
                        bkg_color_hover={'#EEE6DB'}
                        text_color={'#EEE6DB'}
                        text_color_hover={'#361215'}
                        border_color={'#361215'}
                        border_color_hover={'#361215'}
                        font_family={"Great Vibes"}
                        font_size={'30px'}
                        font_weight={'normal'}
                        border_radius={'3px'}
                        width={'350px'}
                        height={'55px'}
                        margin={'10px 0'}
                        letter_spacing={2}
                    />
            }
            {/* <CustomBtn
                type={isRegistered ? 'internal' : 'action'}
                title={isRegistered ? "J'accède à ma formation" : "je rejoins le programme"}
                link={isRegistered ? '/mes-formations/' + slug : null}
                on_click={isRegistered ? null : () => btn_action()}
                bkg_color={'#7D605C'}
                bkg_color_hover={'#EEE6DB'}
                text_color={'#EEE6DB'}
                text_color_hover={'#361215'}
                border_color={'#361215'}
                border_color_hover={'#361215'}
                font_family={"Great Vibes"}
                font_size={'30px'}
                font_weight={'normal'}
                border_radius={'3px'}
                width={'350px'}
                height={'55px'}
                margin={'10px 0'}
                letter_spacing={2}
            /> */}
        </div>
    )
}